<script>
import { settings } from '@/model/gantt/ganttUtils';

export default {
  name: 'GanttArrow',
  props: {
    points: Array,
  },
  computed: {
    pointsStr() { return this.points.map(p => p.join(',')).join(' '); },
    lastPoint() { return this.points.slice(-1)[0]; },
    r() { return settings.bar.circle.r; },
    arrow() {
      return [
        [this.lastPoint[0] - 4, this.lastPoint[1] - 4],
        [...this.lastPoint],
        [this.lastPoint[0] - 4, this.lastPoint[1] + 4],
      ].map(([x, y]) => [x - this.r, y].join(',')).join(' ');
    },
  },
};
</script>

<template lang="pug">
  g.arrow(@click.stop="$emit('delete')" @mousedown.stop)
    //polyline(:points="pointsStr" style="stroke: #6CD796; stroke-width: 1px; fill: none;" stroke-dasharray="6, 4")
    //polyline(:points="arrow" style="stroke: #6CD796; stroke-width: 1px; fill: none;")
    polyline(:points="pointsStr")
    polyline(:points="arrow")
</template>

<style scoped lang="scss">
  g.arrow {
    polyline {
      stroke: rgb(255, 160, 17);
      stroke-width: 1px;
      fill: none;
      cursor: pointer;
    }
    &:hover polyline {
      stroke-width: 2.5px;
    }
  }
</style>
